// extracted by mini-css-extract-plugin
export default {"root":"Status_root__iOLl7","state0":"Status_state0__XbX9t","state1":"Status_state1__hPJSx","state2":"Status_state2__XCFZz"};